<!-- 预约厂商查看现场与标单信息 && 实际厂商查看现场与标单信息 -->
<div class="main">
  <!-- 预约厂商查看现场与标单信息 -->
  <div class="appoint">
    <h4 style="margin-bottom: 16px;margin-top: 16px">{{ 'AppointVendor.AppointVendorTitle' | translate }}</h4>
    <!-- edit厂商查看现场时间 -->
    <div class="editInfo" *ngIf="appointEditStatus; else elseTemplate">
      <nz-list nzBordered>
        <nz-list-item *ngFor="let biditem of bidtimeInfo">
          <div class="facture">
            <div class="span-type">{{ biditem.text }}</div>
            <div class="item-1">
              <span class="span-title">{{ 'AppointVendor.AppointmentData' | translate }}</span>
              <ng-container *ngIf="biditem.value === 'civilfactureData'">
                <nz-date-picker [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
                  [(ngModel)]="civilPreAppointmentData" nzPlaceHolder="Start"
                  (ngModelChange)="nzAppointSelectChanged($event,'preAppointmentData',biditem.value)">
                </nz-date-picker>
                <span>~</span>
                <nz-date-picker #endDatePicker [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
                  [(ngModel)]="civilAfterAppointmentData" nzPlaceHolder="End"
                  (ngModelChange)="nzAppointSelectChanged($event,'afterAppointmentData',biditem.value)">
                </nz-date-picker>
              </ng-container>
              <ng-container *ngIf="biditem.value === 'electrofactureData'">
                <nz-date-picker [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
                  [(ngModel)]="elecPreAppointmentData" nzPlaceHolder="Start"
                  (ngModelChange)="nzAppointSelectChanged($event,'preAppointmentData',biditem.value)">
                </nz-date-picker>
                <span>~</span>
                <nz-date-picker #endDatePicker [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
                  [(ngModel)]="elecAfterAppointmentData" nzPlaceHolder="End"
                  (ngModelChange)="nzAppointSelectChanged($event,'afterAppointmentData',biditem.value)">
                </nz-date-picker>
              </ng-container>
            </div>
            <div class="item-2">
              <span class="span-title">{{ 'AppointVendor.AppointmentDay' | translate }}</span>
              <nz-select [(ngModel)]="appointmentFactureData['appointmentManfacturerData'][biditem.value]['appointmentDay']" [nzOptionOverflowSize]=5
                (ngModelChange)="nzAppointSelectChanged($event,'appointmentDay',biditem.value)">
                <nz-option *ngFor="let item of appointmentDays" [nzValue]="item" [nzLabel]="item + ('AppointVendor.Days' | translate)">
                </nz-option>
              </nz-select>
            </div>
            <div class="item-3">
              <span class="span-title">{{ 'AppointVendor.AppointmentVendorDate' | translate }}</span>
              <span class="head-span2">{{ appointmentFactureData['appointmentManfacturerData'][biditem.value]['appointmentData'] }}</span>
            </div>
          </div>
        </nz-list-item>
      </nz-list>
    </div>
    <!-- read厂商查看现场时间 -->
    <ng-template #elseTemplate>
      <div class="readInfo">
        <nz-list nzBordered>
          <nz-list-item *ngFor="let biditem of bidtimeInfo">
            <div *ngIf="appointmentFactureData.appointmentManfacturerData[biditem.value]['preAppointmentData'] !==undefined" style="width: 100%;">
              <div class="span-type">{{ biditem.text }}</div>
              <div class="item-1">
                <span class="span-title">{{ 'AppointVendor.AppointmentData' | translate }}</span>
                <span class="head-span2">{{ appointmentFactureData.appointmentManfacturerData[biditem.value]['preAppointmentData'] }}</span>
                <span class="head-span2">~</span>
                <span class="head-span2">{{ appointmentFactureData.appointmentManfacturerData[biditem.value]['afterAppointmentData'] }}</span>
              </div>
              <div class="item-2">
                <span class="span-title">{{ 'AppointVendor.AppointmentDay' | translate }}</span>
                <span class="head-span2">{{ appointmentFactureData.appointmentManfacturerData[biditem.value]['appointmentDay'] }}{{ 'AppointVendor.Days' | translate }}</span>
              </div>
              <div class="item-3">
                <span class="span-title">{{ 'AppointVendor.AppointmentVendorDate' | translate }}</span>
                <span class="head-span2">{{ appointmentFactureData.appointmentManfacturerData[biditem.value]['appointmentData'] }}</span>
              </div>
            </div>
          </nz-list-item>
        </nz-list>
      </div>
    </ng-template>
  </div>

  <!-- 实际厂商查看现场与标单信息 -->
  <div class="actual" *ngIf="makeBudgetEstimatesStatus">
    <h4 style="margin-bottom: 16px;margin-top: 16px">{{ 'AppointVendor.ActualVendorTitle' | translate }}</h4>
    <ng-container *ngIf="editBudgetEstimatesStatus; else elseTemplate">
      <!-- edit厂商查看现场时间 -->
      <div class="editInfo">
        <nz-list nzBordered>
          <nz-list-item *ngFor="let biditem of bidtimeInfo">
            <div class="facture">
              <div class="span-type">{{ biditem.text }}</div>
              <div class="item-1">
                <span class="span-title">{{ 'AppointVendor.AppointmentData' | translate }}</span>
                <ng-container *ngIf="biditem.value === 'civilfactureData'">
                  <nz-date-picker [nzDisabled]="reviewResultIsReject" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                  nzFormat="yyyy-MM-dd HH:mm" [(ngModel)]="civilActualViewData" nzPlaceHolder="Start"
                  (ngModelChange)="nztActualSelectChanged($event,'actualViewData',biditem.value)">
                </nz-date-picker>
                </ng-container>
                <ng-container *ngIf="biditem.value === 'electrofactureData'">
                  <nz-date-picker [nzDisabled]="reviewResultIsReject" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                  nzFormat="yyyy-MM-dd HH:mm" [(ngModel)]="elecActualViewData" nzPlaceHolder="Start"
                  (ngModelChange)="nztActualSelectChanged($event,'actualViewData',biditem.value)">
                </nz-date-picker>
                </ng-container>
              </div>
              <div class="item-2">
                <span class="span-title">{{ 'AppointVendor.ActualProvidingDate' | translate }}</span>
                <span class="head-span2">{{ actualFactureData[biditem.value]['actualData'] }}</span>
              </div>
              <div class="item-3">
                <span class="span-title">Status </span>
                <nz-badge *ngIf="actualFactureData[biditem.value]['overTime'] > 0" nzStatus="error">
                  {{ 'AppointVendor.Over' | translate }}
                  <span>{{ actualFactureData[biditem.value]['overTime'] }}</span>
                  {{ 'AppointVendor.Hours' | translate }}
                </nz-badge>
                <nz-badge *ngIf="actualFactureData[biditem.value]['overTime'] <= 0" nzStatus="success">
                  {{ 'AppointVendor.Punctual' | translate }}
                </nz-badge>
              </div>
            </div>
          </nz-list-item>
        </nz-list>
      </div>
    </ng-container>
    <!-- read厂商查看现场时间 -->
    <ng-template #elseTemplate>
      <div class="readInfo">
        <nz-list nzBordered>
          <nz-list-item *ngFor="let biditem of bidtimeInfo">
            <div class="facture">
              <div class="span-type">{{ biditem.text }}</div>
              <div class="item-1">
                <span class="span-title">{{ 'AppointVendor.AppointmentData' | translate }}</span>
                <span class="head-span2">{{ actualFactureData[biditem.value]['actualViewData'] }}</span>
              </div>
              <div class="item-2">
                <span class="span-title">{{ 'AppointVendor.ActualProvidingDate' | translate }}</span>
                <span class="head-span2">{{ actualFactureData[biditem.value]['actualData'] }}</span>
              </div>
              <div class="item-3">
                <span class="span-title">Status</span>
                <nz-badge *ngIf="actualFactureData[biditem.value]['overTime'] > 0" nzStatus="error">
                  {{ 'AppointVendor.Over' | translate }}
                  <span>{{ actualFactureData[biditem.value]['overTime'] }}</span>
                  {{ 'AppointVendor.Hours' | translate }}
                </nz-badge>
                <nz-badge *ngIf="actualFactureData[biditem.value]['overTime'] <= 0" nzStatus="success">
                  {{ 'AppointVendor.Punctual' | translate }}
                </nz-badge>
              </div>
            </div>
          </nz-list-item>
        </nz-list>
      </div>
    </ng-template>
  </div>
</div>